import { useEffect, useState } from "react";
import { Save, Percent } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../../lib/api";

const CATS = [
  { key: "fusti", label: "Fusti Cocktail 19L" },
  { key: "liquori", label: "Liquori in Bottiglia" },
  { key: "granite", label: "Granite & Preparati" },
];

export default function CommissionSettingsPanel() {
  const [rates, setRates] = useState({ fusti: 8, liquori: 10, granite: 8 });
  const [bonus, setBonus] = useState(2);

  useEffect(() => {
    api.get("/settings/commission").then(({ data }) => {
      setRates({ fusti: 8, liquori: 10, granite: 8, ...(data.rates || {}) });
      setBonus(data.new_point_bonus ?? 2);
    }).catch(() => {});
  }, []);

  const save = async () => {
    try {
      const payload = {
        rates: { fusti: Number(rates.fusti), liquori: Number(rates.liquori), granite: Number(rates.granite) },
        new_point_bonus: Number(bonus),
      };
      await api.put("/settings/commission", payload);
      toast.success("Impostazioni provvigioni salvate");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };

  return (
    <div className="max-w-xl">
      <div className="bg-white rounded-2xl border border-stone-200 p-6">
        <div className="flex items-center gap-2 mb-1">
          <Percent className="w-5 h-5 text-[#0F4C81]" />
          <h3 className="font-serif text-xl font-semibold text-[#0B2A45]">Provvigioni a scaglioni</h3>
        </div>
        <p className="text-sm text-stone-500 mb-6">Percentuali applicate agli ordini in base alla categoria di prodotto, più il bonus per l'apertura di un nuovo punto vendita.</p>
        <div className="space-y-4">
          {CATS.map((c) => (
            <div key={c.key} className="flex items-center justify-between gap-4">
              <Label className="text-sm">{c.label}</Label>
              <div className="relative w-32">
                <Input type="number" step="0.5" data-testid={`rate-${c.key}-input`} value={rates[c.key]}
                       onChange={(e) => setRates({ ...rates, [c.key]: e.target.value })} className="pr-7" />
                <span className="absolute right-3 top-1/2 -translate-y-1/2 text-stone-400 text-sm">%</span>
              </div>
            </div>
          ))}
          <div className="flex items-center justify-between gap-4 pt-4 border-t border-stone-200">
            <Label className="text-sm">Bonus nuovo punto (comodato)</Label>
            <div className="relative w-32">
              <Input type="number" step="0.5" data-testid="bonus-input" value={bonus}
                     onChange={(e) => setBonus(e.target.value)} className="pr-7" />
              <span className="absolute right-3 top-1/2 -translate-y-1/2 text-stone-400 text-sm">%</span>
            </div>
          </div>
        </div>
        <Button onClick={save} data-testid="save-commission-btn" className="mt-6 bg-[#0F4C81] text-white rounded-full">
          <Save className="w-4 h-4 mr-2" />Salva impostazioni
        </Button>
      </div>
    </div>
  );
}
